import "../../assets/css/modal.css";
import "../../assets/css/custom.css";
import { useEffect, useRef, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { IoMdCloseCircle } from "react-icons/io";

export default function BorderFailModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="modal-mobile-overlay" onClick={onClose}>
      <div
        style={{
          backgroundColor: `white`,
          // height: `200px`,
          width: `300px`,
          padding: `20px`,
          borderRadius: `8px`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* <div>
          <div className="modal-mobile-header">로그인이 필요합니다.</div>
          <hr color="black" />
        </div> */}
        <div>
          <div
            style={{
              display: `flex`,
              justifyContent: `center`,
              color: `red`,
            }}
          >
            <IoMdCloseCircle size={30} />
          </div>
          <div
            style={{
              display: `flex`,
              width: `100%`,
              justifyContent: `center`,
              alignItems: `center`,
              marginTop: `10px`,
              fontWeight: `800`,
            }}
          >
            문의 작성이 완료되었습니다.
          </div>
          <div
            style={{
              display: `flex`,
              justifyContent: `space-between`,
              marginTop: `10px`,
            }}
          >
            <div
              onClick={onClose}
              style={{
                backgroundColor: `red`,
                display: `flex`,
                justifyContent: `center`,
                alignItems: `center`,
                width: `100%`,
                height: `40px`,
                borderRadius: `8px`,
                fontWeight: `800`,
                fontSize: `16px`,
                color: `white`,
                cursor: `pointer`,
              }}
            >
              확인
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
